import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class PollingErrorIndicator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ticker: 0,
    };
  }

  componentDidUpdate() {
    if (this.props.stateFetchError) {
      clearInterval(this.threeDotsInterval);
      this.threeDotsInterval = setInterval(() => {
        this.setState({ ticker: this.state.ticker + 1 });
      }, 300);
    } else {
      clearInterval(this.threeDotsInterval);
    }
  }

  componentWillUnmount() {
    clearInterval(this.threeDotsInterval);
  }

  render() {
    const { t, stateFetchError } = this.props;

    const dotCount = (this.state.ticker % 4) + 1;
    const dots = Array(dotCount).fill(".").join("");
    const invisibleDots = Array(4 - dotCount).fill(".").join("");

    return (
      <div className="polling-error-indicator" aria-hidden={!stateFetchError} style={{
        display: stateFetchError ? "flex" : "none",
      }}>
        <span className="polling-error-indicator-status">
          { t("polling-error-indicator.connectionLost") }.
        </span>
        <span className="polling-error-indicator-message">
          { t("polling-error-indicator.reconnecting") }
          <span className="polling-error-indicator-dots">
            {dots}<span style={{ visibility: "hidden" }}>{invisibleDots}</span>
          </span>
        </span>
      </div>
    );
  }
}

PollingErrorIndicator.propTypes = {
  t: PropTypes.func.isRequired,
  stateFetchError: PropTypes.any,
};

const mapStateToProps = (state) => ({
  stateFetchError: state.game.error.stateFetchError,
});

export default compose(
  withTranslation("components"),
  connect(mapStateToProps),
)(PollingErrorIndicator);
